import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { API_URI } from 'src/environments/app.config';
import { Observable } from 'rxjs/Observable';
import { BaseService } from 'src/app/services/base.service';
import { LoginRequest } from 'src/app/services/models/auth/login.request.model'
import { Login } from 'src/app/services/models/auth/login.model';
import {Response} from 'src/app/services/models/response.model';
import { VerifyGoogleAuthenRequest } from './models/auth/verifygoogle.authen.request.model';

@Injectable()
export class AuthService extends BaseService {
  constructor(private _http: HttpClient) {
    super(_http);
    this.baseUrl = API_URI.auth;
  }

  login(logindetail: LoginRequest): Observable<Response<Login>> {
    return this.post(`/login`, logindetail, {})
    .map(result => new Response<Login>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  logout(): Observable<Response<any>> {
    return this.post(`/logout`, {}, {})
    .map(result => new Response<any>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  generateAuth(): Observable<Response<any>> {
    let url = `/GenerateAuth`;
    return this.get(url)
    .map(result => new Response<any>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  getCheck(): Observable<Response<any>> {
    let url = `/GetCheck`;
    return this.get(url)
    .map(result => new Response<any>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  verifyGoogleAuthen(data:VerifyGoogleAuthenRequest): Observable<Response<any>> {
    return this.post(`/VerifyGoogleAuthen`, data, {})
    .map(result => new Response<any>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }
}